<template>
  <div class="addFloor-content news-common">
    <heads :title="params.title" @submit="submit"></heads>
    <div class="detail">
      <div class="sub-title">{{params.title}}添加</div>
      <div>
        <el-select v-model="addOptions" multiple placeholder="请选择">
          <el-option v-for="item in options" :key="item.id" :label="item.state" :value="item.id"></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>
<script>
import heads from "@/components/header.vue";
import api from "@/api/news/floorNum.js";
export default {
  components: { heads },
  data() {
    return {
      addOptions: [],
      options: []
    };
  },
  computed: {
    params() {
      return this.$route.query;
    },
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  mounted() {
    this.getSelect();
  },
  methods: {
    async getSelect() {
      let reqdata = {
        communityId: this.userInfo.communityId
      };
      let res = await this.$http.get(`${api.getSelect}`, { params: reqdata });
      if (res && res.isSucceed) {
        this.options = res.rows;
      }
    },
    async submit() {
      if (!this.addOptions || this.addOptions.length <= 0) {
        this.$message.error("请选择需要添加的内容");
        return;
      }
      let reqData = {
        firstApproveDepartment: this.addOptions.join(","),
        communityId: this.userInfo.communityId,
        def1: this.params.level,
        def2: "building_house"
      };
      let res = await this.$http.get(`${api.addFloor}`, { params: reqData });
      if (res && res.isSucceed) {
        this.$message({
          message: "添加成功",
          type: "success"
        });
        this.$router.go(-1);
      }
    }
  }
};
</script>
<style lang='less' scoped>
@import url("./newsCommon.less");
.addFloor-content {
  .detail {
    & > div:nth-child(2) {
      margin-top: 20px;
    }
  }
}
</style>
<style lang='less'>
.addFloor-content {
  .el-input__inner {
    width: 360px;
    height: 36px;
  }
}
</style>

